import UserEntity from "../../../../domain/entities/UserEntity";

export enum UserInListAction { ADD, SEE, REMOVE, NONE };
export default interface UserInListComponentProps {
    user: UserEntity;
    onClick?: () => void;
    action?: UserInListAction;
}